import React from 'react';
import { isEqual } from 'lodash';

import LoadingBlock from 'app/common/components/LoadingBlock';
import MaybeLoad from 'app/common/components/MaybeLoad';

interface Props {
  Component: React.ComponentType<any>;
  isLoading: boolean;
  LoadingComponent?: React.ComponentType<any>;
  onLoad: (props: any) => void;
}

const LoadingBlockOrComponent = (componentProps: Props) => {
  const {
    Component,
    isLoading,
    LoadingComponent = LoadingBlock,
    ...props
  } = componentProps;

  return (
    <MaybeLoad
      Component={isLoading ? LoadingComponent : Component}
      {...props}
    />
  );
};

// Use React.memo with deep equality check (equivalent to purifyWithDeepCheck)
export default React.memo(LoadingBlockOrComponent, (prevProps, nextProps) => {
  // Return true if props are equal (to skip re-render)
  return isEqual(prevProps, nextProps);
});
